// src/CommonAPI.js

export const COMMON_API = "https://madhyadesign.com";